import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LegalPage = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-white pt-24 pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-slate-900 mb-8">Aviso Legal y Condiciones Generales de Uso</h1>
        
        <div className="prose prose-slate max-w-none">
          <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">Términos y Condiciones Generales de Uso y Aviso Legal</h2>
          <p className="text-slate-600 mb-4">de https://ofertas.miluzygas.es, https://www.ofertas-internet.es y www.agencia-ppc.es</p>

          <h3 className="text-lg font-semibold text-slate-800 mt-6 mb-3">Información del editor</h3>
          <p className="text-slate-600 mb-4">
            El sitio web es editado por Ulysse Julien Berneau, empresario individual registrado como Autónomo en España bajo el régimen RETA, identificado con el NIE Y5618264E. Su domicilio profesional se encuentra en Calle Castillejos 276, SA2A, 08025 Barcelona. Puede contactarse por correo electrónico en la dirección info@agencia-ppc.es y por teléfono al +34 613 076 099. En adelante, denominado el "Editor".
          </p>

          <h3 className="text-lg font-semibold text-slate-800 mt-6 mb-3">Responsable de la publicación</h3>
          <p className="text-slate-600 mb-4">
            El Editor, Ulysse Julien Berneau, asume igualmente la responsabilidad de la dirección editorial del sitio.
          </p>

          <h3 className="text-lg font-semibold text-slate-800 mt-6 mb-3">Alojamiento del sitio</h3>
          <p className="text-slate-600 mb-4">
            Este sitio ha sido creado mediante la plataforma SwipePages, operada por Arrow Labs Pte Ltd, empresa registrada en Singapur con el número 202017518C. Su sede social se encuentra en 20 Cecil Street, #05-03 Plus, Singapore 049705. Sitio web: https://swipepages.com
          </p>

          <h3 className="text-lg font-semibold text-slate-800 mt-6 mb-3">Terminología utilizada</h3>
          <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
            <li>El término "Sitio" se refiere al conjunto de páginas accesibles a través de las URL: https://ofertas.miluzygas.es, https://www.ofertas-internet.es et www.agencia-ppc.es</li>
            <li>El "Servicio" designa las herramientas gratuitas que permiten comparar ofertas de energía o internet y contactar por teléfono a un Socio comercial.</li>
            <li>El "Usuario" o "Visitante" es cualquier persona mayor de edad y con capacidad legal que accede al Sitio.</li>
            <li>El "Socio" es una empresa externa autorizada a ofrecer contratos de energía, telecomunicaciones o servicios similares, y con la cual se puede establecer contacto mediante el Sitio.</li>
          </ul>

          <h3 className="text-lg font-semibold text-slate-800 mt-6 mb-3">Finalidad de las presentes disposiciones</h3>
          <p className="text-slate-600 mb-4">
            Estas condiciones regulan únicamente el acceso al Sitio y el uso de sus funcionalidades. No regulan ni la prestación efectiva del suministro eléctrico o de internet, ni la relación contractual que eventualmente pueda establecerse entre el Usuario y un proveedor de servicios.
          </p>

          <h3 className="text-lg font-semibold text-slate-800 mt-6 mb-3">Naturaleza y límites del servicio</h3>
          <p className="text-slate-600 mb-4">
            La información mostrada en el Sitio proviene de fuentes públicas o es proporcionada directamente por los proveedores. Se presenta exclusivamente a título informativo y no constituye ni un asesoramiento financiero ni una recomendación personalizada, conforme al artículo 60.2 del Real Decreto Legislativo 1/2007 (TRLGDCU).
          </p>

          <h3 className="text-lg font-semibold text-slate-800 mt-6 mb-3">Llamadas y contacto con Socios</h3>
          <p className="text-slate-600 mb-4">
            En el Sitio se proporciona un número de teléfono sin recargo adicional para contactar con un Socio. El coste de la llamada corresponde al de una llamada local (sin sobrecostes impuestos por el operador).
          </p>
          <p className="text-slate-600 mb-4">
            El Editor no ofrece directamente productos o servicios de energía o internet, no gestiona contrataciones ni pagos, pero puede recibir una comisión si se celebra un contrato con un Socio a través del Sitio. Esta remuneración no afecta el precio final pagado por el Usuario.
          </p>

          <h3 className="text-lg font-semibold text-slate-800 mt-6 mb-3">Disponibilidad del Sitio</h3>
          <p className="text-slate-600 mb-4">
            El Sitio está disponible de forma continua, salvo operaciones de mantenimiento o casos de fuerza mayor. El Editor se reserva el derecho de suspender el acceso al mismo en cualquier momento y sin previo aviso.
          </p>

          <h3 className="text-lg font-semibold text-slate-800 mt-6 mb-3">Funcionamiento del comparador</h3>
          <p className="text-slate-600 mb-4">
            La única finalidad de la herramienta de comparación es ayudar al Usuario a comprender mejor el mercado. No se ofrece análisis individualizado ni asesoramiento personalizado.
          </p>
          <p className="text-slate-600 mb-4">
            La elección final del proveedor recae únicamente en el Usuario.
          </p>
          <p className="text-slate-600 mb-4">
            El Editor no se responsabiliza de posibles errores, inexactitudes o información desactualizada, ni de las decisiones tomadas por el Usuario en base a dicha información.
          </p>
          <p className="text-slate-600 mb-4">
            El Usuario se compromete a proporcionar información veraz al utilizar el servicio y reconoce que es su responsabilidad contactar directamente con los proveedores para cualquier duda adicional.
          </p>

          <h3 className="text-lg font-semibold text-slate-800 mt-6 mb-3">Responsabilidades</h3>
          <p className="text-slate-600 mb-4">
            Pese al cuidado dedicado a la verificación de los datos, el Editor no garantiza la exhaustividad ni la exactitud de las ofertas mostradas.
          </p>
          <p className="text-slate-600 mb-4">
            Toda decisión de contratación es asumida bajo la entera responsabilidad del Usuario.
          </p>
          <p className="text-slate-600 mb-4">
            El Editor no se responsabiliza del contenido de enlaces externos, interrupciones del Sitio, o daños derivados del uso de la información disponible.
          </p>

          <h3 className="text-lg font-semibold text-slate-800 mt-6 mb-3">Obligaciones del Usuario</h3>
          <p className="text-slate-600 mb-2">Al acceder al Sitio, el Usuario se compromete a:</p>
          <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
            <li>Respetar la legislación vigente.</li>
            <li>No alterar ni manipular el funcionamiento del Sitio.</li>
            <li>Proteger sus credenciales de acceso, si las hubiera.</li>
            <li>Proporcionar información veraz y exacta al comunicarse con un Socio comercial.</li>
          </ul>

          <h3 className="text-lg font-semibold text-slate-800 mt-6 mb-3">Derechos de autor y propiedad intelectual</h3>
          <p className="text-slate-600 mb-4">
            Todos los contenidos del Sitio (textos, gráficos, logotipos, diseño visual, formularios, estructura del sitio, etc.) son propiedad exclusiva del Editor.
          </p>
          <p className="text-slate-600 mb-4">
            Cualquier reproducción, distribución o modificación – incluso parcial – está estrictamente prohibida sin autorización previa por escrito.
          </p>
          <p className="text-slate-600 mb-4">
            El uso del Sitio se limita a un uso personal, temporal y no comercial.
          </p>
          <p className="text-slate-600 mb-4">
            Toda infracción podrá dar lugar a acciones legales.
          </p>

          <h3 className="text-lg font-semibold text-slate-800 mt-6 mb-3">Protección de datos personales</h3>
          <p className="text-slate-600 mb-4">
            No se recogen datos personales directamente a través del Sitio, salvo los necesarios mediante cookies técnicas.
          </p>
          <p className="text-slate-600 mb-4">
            Solo se procesan datos técnicos relacionados con la navegación, conforme a la política de cookies del Sitio.
          </p>
          <p className="text-slate-600 mb-4">
            Conforme al Reglamento General de Protección de Datos (UE) 2016/679 y la Ley Orgánica 3/2018 de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD), los derechos de acceso, rectificación, supresión, oposición o portabilidad pueden ejercerse enviando un correo electrónico a: info@agencia-ppc.es
          </p>

          <h3 className="text-lg font-semibold text-slate-800 mt-6 mb-3">Seguridad y modificaciones de las condiciones</h3>
          <p className="text-slate-600 mb-4">
            Se aplican medidas de seguridad adaptadas a los estándares técnicos vigentes para proteger el Sitio.
          </p>
          <p className="text-slate-600 mb-4">
            No obstante, el Usuario acepta los riesgos inherentes a toda conexión en Internet.
          </p>
          <p className="text-slate-600 mb-4">
            Estas condiciones pueden modificarse en cualquier momento. La versión publicada en el Sitio es la que prevalece en el momento de la consulta.
          </p>

          <h3 className="text-lg font-semibold text-slate-800 mt-6 mb-3">Legislación aplicable y resolución de conflictos</h3>
          <p className="text-slate-600 mb-4">
            Las presentes condiciones se rigen por la legislación española.
          </p>
          <p className="text-slate-600 mb-4">
            En caso de controversia, las partes se someterán a los Juzgados y Tribunales de Barcelona, salvo disposición legal imperativa en contrario.
          </p>

          <h3 className="text-lg font-semibold text-slate-800 mt-6 mb-3">Contacto</h3>
          <p className="text-slate-600 mb-4">
            Para cualquier pregunta relativa a estas condiciones o al funcionamiento del Sitio, puede contactar con el Editor en la siguiente dirección: info@agencia-ppc.es
          </p>
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
